<template>

	<!--bottom-->
	<div class="bg4">
		<div class="bottom">
			<div class="bottom1" >
				<div class="bottom1_2">
					<div class="bottom_t">服务电话</div>
					<div class="bottom_tel">
						<pre>{{configData2.configValue}}</pre>
						
						
					</div>
				</div>
				<div class="bottom1_2">
					<div class="bottom_t">服务机构</div>
					<pre>{{configData.configValue}}</pre>
				
				</div>
				<div class="bottom1_1">
					<div class="bottom_t" ><a @click="go('/about')" href="javascript:void(0)">关于数码人</a></div>
					<ul class="link_list">
						<li><a @click="go('/about')" href="javascript:void(0)">数码人简介 </a></li>
						<li><a @click="go('/contact')" href="javascript:void(0)">联系我们 </a></li>
						<li><a @click="go('/newList')" href="javascript:void(0)">公司新闻 </a></li>
						<li><a @click="go('/honorList')" href="javascript:void(0)">资质荣誉 </a></li>
						<li><a @click="go('/ipList')" href="javascript:void(0)"> 知识产权</a></li>
						<li><a @click="go('/clientList')" href="javascript:void(0)"> 客户名录</a></li>
					</ul>
				</div>
				<div class="bottom1_1">
					<div class="bottom_t"><a @click="go('/solutionList')" href="javascript:void(0)">解决方案</a></div>
					<ul class="link_list">
						<li v-for="item in solutionList">
							<!-- <a @click="go('/solutionList?id=' + item.categoryCode + '&name=' + item.categoryName)" href="javascript:void(0)"> -->
								<a @click="goNext2(item.categoryCode,item.categoryName)" href="javascript:void(0)">
								
							{{ item.categoryName
								}}</a></li>
					</ul>
				</div>
				<div class="bottom1_1">
					<div class="bottom_t"><a @click="go('/caseList')" href="javascript:void(0)">案例推荐</a></div>
					<ul class="link_list">
						<!-- <li v-for="item in caseList"><a @click="go('/caseDetail?id=' + item.id)" href="javascript:void(0)">{{ item.clientName }}</a>
						</li> -->
						<li v-for="item in solutionList">
							<a @click="goNext3(item.categoryCode,item.categoryName)"  href="javascript:void(0)">	{{ item.categoryName}}</a></li>
					</ul>
				</div>
				<div class="bottom1_1">
					<div class="bottom_t"><a @click="go('/clientList')" href="javascript:void(0)">客户列表</a></div>
					<ul class="link_list">
						<li v-for="item in clientList" :key="item.value"><a @click="go('/clientList?region=' + item.name)" href="javascript:void(0)">{{
							item.name }} </a></li>

					</ul>
				</div>
			</div>
			<div class="bottom2">©青岛数码人网络科技有限公司 <a href="javascript:void(0)">鲁ICP备15002286号-1</a> </div>
			<div class="bottom3">©青岛数码人网络科技有限公司 <a href="javascript:void(0)">鲁ICP备15002286号-1</a> </div>
			<!--shouji bottom-->

		</div>
	</div>
	<!--bottom-->

</template>
<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import {
	getTreeList,
	getDictList,
	getCaseList,
	getConfig
} from '@/api/reqFetch.js'
export default {

	name: '',
	layout: '',
	components: {
		Footer,
		Header,
	},
	data() {
		return {
			list: [],
			caseList: [],
			configData: {},
			configData2: {},
			solutionList: [],
			clientList: [],
			
		}
	},
	filters: {
		filterDay(val) {
			return val.split('-')[2]
		},
		filterDate(val) {
			return val.split('-')[0] + '-' + val.split('-')[1]
		}
	},

	mounted() {
		this.getTreeList()
		this.getDictList()
		this.getCaseList()
		this.getConfig()
	},

	methods: {
		getDictList() {
			getDictList({
				dictType: 'cms_client_region'
			}).then(res => {
				this.clientList = res.data.dictList;
			});
		},
		go(url) {
			if (this.$route.fullPath != url) {
				this.$router.push(url)
				this.$router.go(0)
			}
		},


		getTreeList() {
			getTreeList({
				categoryCode: '2000',
			}).then(res => {
				this.solutionList = res.data[0].childList
			});
		},

		getCaseList() {
			getCaseList({
				categoryCode: '',
				pageNum: 1,
				categoryName: '',
				pageSize: 6,
			}).then(res => {
				this.caseList = res.data.list
			});
		},
		getConfig() {
			getConfig({
			
			}).then(res => {
				this.configData = res.data.cms_contactus_address
				this.configData2 = res.data.cms_contactus_mobile
			});
		},
		goNext2(id,name) {
			this.$router.push({
				path: '/solutionList',
				query: {
					id: id,
					name:name
				}
			}).then(() => {
					// 跳转成功后刷新页面
					window.location.reload();
				});
		},
		goNext3(id,name) {
			this.$router.push({
				path: '/caseList',
				query: {
					id: id,
					name:name
				}
			}).then(() => {
					// 跳转成功后刷新页面
					window.location.reload();
				});
		},
	}
}
</script>
<style scoped></style>
